<p-panel
         [header]="'common.actions' | hisUi"
         [toggleable]="true">
    <div class="layoutBlock">
        @if (hisAuthService.hasAny("RIGHT_CS_BIA_ANALYSIS_CREATE_ANALYSIS")){
        <button
                (click)="switchTable()"
                [hisImage]="'TABLE'"
                class="plamButton icon"
                [title]="'cs.bia.analysis.showFlatTable' | hisUi">
            Zur Ansicht {{ tableTypeText | hisUi }}
        </button>
        }

        @if (headerOrder.length > 1) {
        <button
                (click)="op.show($event)"
                [hisImage]="'CHART_ORG_PENCIL'"
                class="plamButton icon"
                [title]="'cs.bia.analysis.columns.customize.tooltip' | hisUi">
            {{ "cs.bia.analysis.columns.customize" | hisUi }}
        </button>
        }

        @if (hisAuthService.hasAny("RIGHT_CS_BIA_ANALYSIS_CREATE_ANALYSIS")
        && enableReportSharing && edit === true) {
        <his-bi-save-bi-analysis
                                 [report]="report"
                                 (reportChanged)="onSaveReport($event)">
        </his-bi-save-bi-analysis>
        }

        @if (hisAuthService.hasAny("RIGHT_CS_BIA_ANALYSIS_CREATE_ANALYSIS")
        && enableReportSharing ) {
        <his-bi-create-permalink
                                 [storedReportId]="report.id"
                                 [reportName]="report.name ?? ''">
        </his-bi-create-permalink>
        }
        @if (tableTypeText !== "cs.bia.analysis.hierarchicalTable") {
        <button
                (click)="download(true)"
                hisImage="PAGE_WHITE_EXCEL"
                [title]="'cs.bia.analysis.export.excel.hierarchy.tooltip' | hisUi"
                class="transparent">
            {{ "cs.bia.analysis.export.excel.hierarchy.button" | hisUi }}
        </button>
        }
        <button
                (click)="download(false)"
                hisImage="PAGE_WHITE_EXCEL"
                [title]="'cs.bia.analysis.export.excel.flat.tooltip' | hisUi"
                class="transparent">
            {{ "cs.bia.analysis.export.excel.flat.button" | hisUi }}
        </button>

        @if (hisAuthService.hasAll("RIGHT_CS_BIA_ANALYSIS_CREATE_JASPER_TEMPLATE")) {
        <button
                [disabled]="!report.id"
                (click)="downloadJR()"
                hisImage="DOWNLOAD"
                class="transparent">
            {{ "cs.bia.analysis.exportJasperReport.button" | hisUi }}
        </button>
        }

        @if (hisAuthService.hasAny("RIGHT_CS_BIA_ANALYSIS_MANAGE_JSON")) {
        <button
                (click)="downloadJson()"
                hisImage="PAGE_WHITE_CODE"
                [title]="'cs.bia.analysis.reportDefinition.json.tooltip' | hisUi"
                class="transparent">
            {{ "cs.bia.analysis.reportDefinition.json.button" | hisUi }}
        </button>
        }
    </div>
</p-panel>

<p-overlayPanel
                #op
                [showCloseIcon]="true">
    <h2>{{ "cs.bia.analysis.columns.customize" | hisUi }}</h2>
    <ng-template pTemplate>
        <his-plam
                  [showLabelTop]="true"
                  [label]="'cs.bia.analysis.columns.rearrange' | hisUi">
            <p-orderList
                         [header]="'Spaltenattribute & Kennzahlen'"
                         [value]="headerOrder"
                         #content
                         hisDdKey="Auswahlliste Label"
                         breakpoint="575px"
                         (onReorder)="rearrangeHeader()"
                         [dragdrop]="true">
                <ng-template
                             let-order
                             pTemplate="item">
                    <div>
                        <div class="orderlistItem">
                            {{ order }}
                        </div>
                    </div>
                </ng-template>
            </p-orderList>
        </his-plam>
        <h3>{{ "cs.bia.analysis.columns.total" | hisUi }}</h3>
        <his-plam
                  label="{{ 'cs.bia.analysis.columns.total.checkbox' | hisUi }}"
                  helptext="cs.bia.analysis.columns.total.checkbox.helptext"
                  class="leftAlignedCheckbox">
            <input
                   type="checkbox"
                   #content
                   [(ngModel)]="report.showTotalColumn"
                   (change)="setTotalColumn()" />
        </his-plam>
    </ng-template>
</p-overlayPanel>